import { appURLs } from "@/app/constants.mjs";
import { getRitoLanguageCodeFromBCP47 } from "@/app/util.mjs";
import getArenaAugmentsStats from "@/game-lol/apis/arenaAugmentStats.mjs";
import getArenaChampionStats from "@/game-lol/apis/arenaChampion.mjs";
import getArenaChampionsStats from "@/game-lol/apis/arenaChampions.mjs";
import getArenaChampionsDuosStats from "@/game-lol/apis/arenaChampionsDuos.mjs";
import getChampionStats from "@/game-lol/apis/champion.mjs";
import getChampionAggregates from "@/game-lol/apis/championAggregates.mjs";
import getChampionBuilds from "@/game-lol/apis/championBuilds.mjs";
import getChampionByDurationStats from "@/game-lol/apis/championByDurationStats.mjs";
import getChampionByMinuteStats from "@/game-lol/apis/championByMinuteStats.mjs";
import getChampionMatchups from "@/game-lol/apis/championMatchups.mjs";
import getChampionsStats from "@/game-lol/apis/champions.mjs";
import getChampionSynergies from "@/game-lol/apis/championSynergies.mjs";
import getDoombotsLeaderboard from "@/game-lol/apis/doombotsLeaderboard.mjs";
import getMatch from "@/game-lol/apis/match.mjs";
import getMatchList from "@/game-lol/apis/matchlist.mjs";
import getMatchTimeline from "@/game-lol/apis/matchTimeline.mjs";
import getPlaystyles from "@/game-lol/apis/playstyles.mjs";
import postPostmatchLPElixir_DEPRECATE_SOON from "@/game-lol/apis/post-postmatch-lp-elixir.mjs";
import postRankUpdateElixir_DEPRECATE_SOON from "@/game-lol/apis/post-rank-update-elixir.mjs";
import getProfile from "@/game-lol/apis/profile.mjs";
import { getProPlayers } from "@/game-lol/apis/proPlayers.mjs";
import { getProTeams } from "@/game-lol/apis/proTeams.mjs";
import getSynergies from "@/game-lol/apis/synergies.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";
import { getLocale } from "@/util/i18n-helper.mjs";

// Aggregate APIs
// Big data aggregates of millions of games
// Non-player specific, typically provided by Datalake
// Things like tier lists, champion stats, builds, divisionStats, etc
export const AGGREGATE = {
  getChampionBuilds,
  getChampionStats,
  getChampionMatchups,
  getChampionsStats,
  getSynergies,
  getChampionSynergies,
  getChampionByMinuteStats,
  getChampionByDurationStats,
  getArenaAugmentsStats,
  getArenaChampionsStats,
  getArenaChampionsDuosStats,
  getArenaChampionStats,

  getDoombotsLeaderboard,
};

// Player specific data like profiles, matchlist, match, playstyles etc
export const PLAYER = {
  getProfile,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProfileRanks: (_any: any) => Promise.resolve(), // New endpoint for profile ranks
  getMatchList,
  getMatch,
  getMatchTimeline,
  getPlaystyles,
  getChampionAggregates,
  postPostmatchLPElixir_DEPRECATE_SOON,
  postRankUpdateElixir_DEPRECATE_SOON,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postPostmatchLP: (_any: any) => Promise.resolve(),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postRankUpdate: (_any: any) => Promise.resolve(),

  getPlayerChampionSeasonStats(variables = {}) {
    return queryGQL(
      appURLs.LOL_LEAGUE_PLAYER,
      GraphQLTemplates.fetchUserChampionsSeason,
      variables,
    );
  },
  getPlayerBasicChampionStats(variables) {
    return queryGQL(
      appURLs.LOL_LEAGUE_PLAYER,
      GraphQLTemplates.fetchUserBasicChampions,
      variables,
    );
  },
};

export const STATIC = {
  getStaticVersions: () => `${appURLs.UTILS_STATIC}/lol/riot/versions`,
  getStaticData: (version, entry) => {
    if (entry === "spells") entry = "summoners";
    const lang = getLocale();
    return `${
      appURLs.CDN_PLAIN
    }/blitz/ddragon/${version}/data/${getRitoLanguageCodeFromBCP47(
      lang,
    )}/${entry}.json`;
  },
  getArenaAugments(patch, lang) {
    return `${
      appURLs.UTILS_STATIC
    }/lol/arena/${patch}/augments_${lang.toLowerCase()}`;
  },
  getArenaAnvils(patch, lang) {
    return `${
      appURLs.UTILS_STATIC
    }/lol/arena/${patch}/anvil_${lang.toLowerCase()}`;
  },
};

export const PROBUILDS = {
  getProPlayers,
  getProTeams,

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProMatchHistory(_any: any): Promise<any> {
    return Promise.resolve();
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getChampionProMatches(_any: any): Promise<any> {
    return Promise.resolve();
  },

  // Currently offline, revisit but new API needs to be made
  getChampionCompetitiveMatches(id, role, amount = 8, tournamentTypes) {
    return queryGQL(
      appURLs.PROBUILDS_URL,
      GraphQLTemplates.CompetitiveMatches,
      {
        championId: id,
        role,
        first: amount,
        tournamentTypes,
      },
    );
  },
};

export const CMS = {
  getChampionInsights() {
    return `${appURLs.UTILS_STATIC}/nexus/lol/champion-insights`;
  },
};
